import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const NICHES = [
  "Real Estate Agents","Insurance Agents","Loan Consultants","Digital Marketing Agency",
  "Web Development Company","Interior Designers","Restaurants","Hospitals & Clinics",
  "Car Dealers","Gym & Fitness Centers","CA & Tax Consultants","Wedding Planners",
  "Travel Agencies","IT Companies","Schools & Coaching Centers","Builders & Contractors",
  "Solar Energy Companies","Pharma Companies","Export Companies","Event Planners",
  "Beauty Parlours & Salons","Dentists","Architects","Lawyers & Advocates",
  "Chartered Accountants","Pest Control Services","Packers & Movers","Catering Services",
  "Photography Studios","E-commerce Businesses",
];
const CITIES = [
  "Delhi","Mumbai","Bangalore","Chennai","Hyderabad","Kolkata","Pune","Ahmedabad",
  "Jaipur","Lucknow","Chandigarh","Surat","Indore","Bhopal","Nagpur","Patna",
  "Vadodara","Coimbatore","Kochi","Visakhapatnam","Noida","Gurgaon","Faridabad",
  "Ghaziabad","Meerut","Agra","Varanasi","Ludhiana","Amritsar","Jodhpur",
];

const SRC_COLOR = {
  "Google Maps":"#4285f4","Google Search":"#4285f4",
  "JustDial":"#e8441a","IndiaMart":"#ff6600","Sulekha":"#00a651","LinkedIn":"#0a66c2","Naukri":"#d4291b","YellowPages":"#f5c518",
};

const intentStyle = {
  hot:  { bg:"#00d4aa18", color:"#00d4aa", border:"#00d4aa44" },
  warm: { bg:"#f59e0b18", color:"#f59e0b", border:"#f59e0b44" },
  cold: { bg:"#6b728018", color:"#6b7280", border:"#6b728044" },
};

const scoreColor = s => s >= 75 ? "#00d4aa" : s >= 50 ? "#f59e0b" : "#f87171";

export default function FreeLead() {
  const [query, setQuery]     = useState("");
  const [city, setCity]       = useState("");
  const [custom, setCustom]   = useState("");
  const [loading, setLoading] = useState(false);
  const [leads, setLeads]     = useState(null);
  const [status, setStatus]   = useState({ used:0, remaining:2, is_premium:false });
  const [error, setError]     = useState("");
  const navigate = useNavigate();
  const email = localStorage.getItem("email") || "";

  useEffect(() => {
    if (!email) { navigate("/"); return; }
    API.get("/leads")
      .then(r => {
        setStatus(r.data);
        if (r.data.is_premium) navigate("/search");
      })
      .catch(() => {});
  }, [email, navigate]);

  const doSearch = async () => {
    const niche = custom.trim() || query;
    if (!niche) { setError("Please select or type a niche/industry."); return; }
    if (!city)  { setError("Please select a city."); return; }
    if (status.remaining <= 0) { navigate("/payment"); return; }
    setError(""); setLoading(true); setLeads(null);
    try {
      const res = await API.post("/free-search", { niche, city });
      setLeads(res.data.leads || []);
      setStatus(s => ({ ...s, used: res.data.used, remaining: res.data.remaining }));
    } catch (e) {
      const msg = e?.response?.data?.detail || "Search failed. Please try again.";
      if (e?.response?.status === 403) { navigate("/payment"); return; }
      setError(msg);
    }
    setLoading(false);
  };

  const reset = () => { setLeads(null); setQuery(""); setCity(""); setCustom(""); setError(""); };

  return (
    <div style={{ minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Syne:wght@700;900&display=swap" rel="stylesheet" />
      <style>{`
        @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        .lead-card{animation:fadeIn 0.4s ease both}
        .lead-card:hover{border-color:#00d4aa33!important}
        select option{background:#0d0d1f;color:#fff}
      `}</style>

      <div style={{ maxWidth:800, margin:"0 auto", padding:"36px 20px" }}>

        {/* Header */}
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div onClick={() => navigate("/")} style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:900, color:"#00d4aa", marginBottom:10, cursor:"pointer" }}>⚡ LeadBot Pro</div>
          <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:32, fontWeight:900, marginBottom:10, lineHeight:1.2 }}>
            {status.remaining > 0 ? "Search Your Free Leads" : "Free Searches Used Up"}
          </h1>

          {/* Search counter */}
          <div style={{ display:"inline-flex", alignItems:"center", gap:10, background:"#0d0d1f", border:"1px solid #ffffff11", borderRadius:50, padding:"10px 22px", marginBottom:18 }}>
            {[0,1].map(i => (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:6 }}>
                <div style={{ width:10, height:10, borderRadius:"50%", background: i < status.used ? "#6b7280" : "#00d4aa", animation: i < status.used ? "none" : "pulse 1.5s infinite" }} />
                <span style={{ fontSize:13, color: i < status.used ? "#6b7280" : "#00d4aa", fontWeight:600 }}>
                  Search {i+1}: {i < status.used ? "Used" : "Free"}
                </span>
              </div>
            ))}
          </div>

          <p style={{ color:"#9ca3af", fontSize:15, marginBottom:16 }}>
            Real data from 6 platforms — Google Maps, JustDial, IndiaMart, Sulekha, LinkedIn & Naukri
          </p>
          <div style={{ display:"flex", gap:8, justifyContent:"center", flexWrap:"wrap" }}>
            {["Google Maps","JustDial","IndiaMart","Sulekha"].map(p => (
              <span key={p} style={{ background:(SRC_COLOR[p]||"#333")+"22", color:SRC_COLOR[p]||"#9ca3af", border:"1px solid "+(SRC_COLOR[p]||"#333")+"44", borderRadius:20, padding:"4px 14px", fontSize:12, fontWeight:700 }}>{p}</span>
            ))}
          </div>
        </div>

        {/* UPGRADE WALL */}
        {status.remaining <= 0 && !leads && (
          <div style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"2px solid #00d4aa55", borderRadius:24, padding:44, textAlign:"center" }}>
            <div style={{ fontSize:52, marginBottom:16 }}>🔓</div>
            <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:900, marginBottom:12 }}>Both Free Searches Used</h2>
            <p style={{ color:"#9ca3af", fontSize:16, maxWidth:420, margin:"0 auto 28px", lineHeight:1.6 }}>
              Upgrade to get 500–Unlimited leads from Google Maps, JustDial, IndiaMart, Sulekha and more — every single month.
            </p>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, maxWidth:480, margin:"0 auto 28px" }}>
              {[["✓","Real phone numbers"],["✓","AI-scored leads"],["✓","Auto-delivery"]].map(([icon,t],i) => (
                <div key={i} style={{ background:"#00d4aa11", border:"1px solid #00d4aa22", borderRadius:10, padding:"10px 8px", fontSize:13, color:"#00d4aa" }}>{icon} {t}</div>
              ))}
            </div>
            <button onClick={() => navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:14, padding:"16px 44px", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:17, cursor:"pointer", marginBottom:14, display:"block", margin:"0 auto 14px" }}>
              🚀 Upgrade Now — View Plans
            </button>
            <button onClick={() => navigate("/dashboard")} style={{ background:"transparent", color:"#6b7280", border:"none", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", display:"block", margin:"0 auto" }}>
              ← Back to Dashboard
            </button>
          </div>
        )}

        {/* SEARCH FORM */}
        {status.remaining > 0 && !leads && (
          <div style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"1px solid #ffffff0d", borderRadius:24, padding:28 }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
              <div>
                <label style={{ display:"block", color:"#9ca3af", fontSize:11, marginBottom:8, textTransform:"uppercase", letterSpacing:1 }}>Industry / Niche *</label>
                <select value={query} onChange={e => { setQuery(e.target.value); setCustom(""); }} style={{ width:"100%", background:"#050510", border:"1px solid #ffffff22", borderRadius:10, padding:"13px 14px", color:query?"#fff":"#6b7280", fontFamily:"'DM Sans',sans-serif", fontSize:14, boxSizing:"border-box", outline:"none" }}>
                  <option value="">Select a niche...</option>
                  {NICHES.map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display:"block", color:"#9ca3af", fontSize:11, marginBottom:8, textTransform:"uppercase", letterSpacing:1 }}>City *</label>
                <select value={city} onChange={e => setCity(e.target.value)} style={{ width:"100%", background:"#050510", border:"1px solid #ffffff22", borderRadius:10, padding:"13px 14px", color:city?"#fff":"#6b7280", fontFamily:"'DM Sans',sans-serif", fontSize:14, boxSizing:"border-box", outline:"none" }}>
                  <option value="">Select a city...</option>
                  {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ display:"block", color:"#9ca3af", fontSize:11, marginBottom:8, textTransform:"uppercase", letterSpacing:1 }}>Or Type Your Own Niche</label>
              <input placeholder="e.g. Solar dealers, Pet clinics, Yoga studios, Electric vehicle showrooms..." value={custom} onChange={e => { setCustom(e.target.value); if (e.target.value) setQuery(""); }} onKeyDown={e => e.key==="Enter" && doSearch()} style={{ width:"100%", background:"#050510", border:"1px solid #ffffff22", borderRadius:10, padding:"13px 14px", color:"#fff", fontFamily:"'DM Sans',sans-serif", fontSize:14, boxSizing:"border-box", outline:"none" }} />
            </div>
            {error && (
              <div style={{ background:"#f8717122", border:"1px solid #f87171", borderRadius:10, padding:"12px 16px", marginBottom:16, color:"#f87171", fontSize:14, display:"flex", alignItems:"center", gap:8 }}>
                ⚠️ {error}
              </div>
            )}
            <button onClick={doSearch} disabled={loading} style={{ width:"100%", background:loading?"#1a1a2e":"linear-gradient(135deg,#00d4aa,#00b894)", color:loading?"#6b7280":"#050510", border:"none", borderRadius:12, padding:"15px", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:16, cursor:loading?"not-allowed":"pointer", transition:"all 0.3s", display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
              {loading ? (
                <>
                  <span style={{ display:"inline-block", animation:"spin 0.8s linear infinite", fontSize:18 }}>⚡</span>
                  Searching Google Maps, JustDial, IndiaMart, Sulekha...
                </>
              ) : `🔍 Search Leads — ${status.remaining} Free Search${status.remaining!==1?"es":""} Left`}
            </button>
            <p style={{ textAlign:"center", marginTop:10, color:"#4b5563", fontSize:12 }}>
              {status.used}/2 searches used · Real business data · No fake entries
            </p>
          </div>
        )}

        {/* RESULTS */}
        {leads && (
          <div style={{ animation:"fadeIn 0.5s ease" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20, flexWrap:"wrap", gap:12 }}>
              <div>
                <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:900, marginBottom:4 }}>
                  {leads.length > 0 ? `✅ ${leads.length} Real Leads Found` : "No Results Found"}
                </h2>
                <p style={{ color:"#9ca3af", fontSize:13 }}>Sourced from 4 platforms · AI-scored by intent</p>
              </div>
              <div style={{ display:"flex", gap:10 }}>
                {status.remaining > 0 && (
                  <button onClick={reset} style={{ background:"#ffffff11", color:"#9ca3af", border:"1px solid #ffffff22", borderRadius:10, padding:"9px 18px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>
                    New Search ({status.remaining} left)
                  </button>
                )}
                <button onClick={() => navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:10, padding:"9px 20px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>
                  🚀 Get 500+ Leads
                </button>
              </div>
            </div>

            {leads.length === 0 ? (
              <div style={{ background:"#0d0d1f", border:"1px solid #ffffff11", borderRadius:20, padding:48, textAlign:"center" }}>
                <div style={{ fontSize:44, marginBottom:16 }}>🔍</div>
                <p style={{ color:"#9ca3af", fontSize:15, marginBottom:20 }}>No businesses found for this search. Try a different niche or city.</p>
                <button onClick={reset} style={{ background:"#00d4aa22", color:"#00d4aa", border:"1px solid #00d4aa44", borderRadius:10, padding:"10px 24px", cursor:"pointer", fontSize:14, fontFamily:"'DM Sans',sans-serif" }}>
                  Try Different Search
                </button>
              </div>
            ) : (
              <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                {leads.map((lead, i) => {
                  const ist = intentStyle[lead.intent] || intentStyle.warm;
                  const sc = SRC_COLOR[lead.source] || "#9ca3af";
                  return (
                    <div key={i} className="lead-card" style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"1px solid #ffffff0a", borderRadius:18, padding:22, display:"grid", gridTemplateColumns:"54px 1fr auto", gap:16, alignItems:"start", transition:"border-color 0.2s", animationDelay:`${i*0.05}s` }}>
                      {/* Score */}
                      <div style={{ width:54, height:54, borderRadius:14, background:scoreColor(lead.score||0)+"18", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", border:"1px solid "+scoreColor(lead.score||0)+"55", flexShrink:0 }}>
                        <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:900, color:scoreColor(lead.score||0), fontSize:20, lineHeight:1 }}>{lead.score||"?"}</div>
                        <div style={{ fontSize:8, color:"#6b7280", marginTop:2, textAlign:"center", textTransform:"uppercase" }}>Score</div>
                      </div>
                      {/* Info */}
                      <div>
                        <div style={{ fontWeight:700, fontSize:16, marginBottom:7, color:"#fff", lineHeight:1.3 }}>{lead.name}</div>
                        <div style={{ display:"flex", gap:16, fontSize:13, flexWrap:"wrap", marginBottom:7 }}>
                          {lead.phone  && <span style={{ color:"#00d4aa" }}>📞 {lead.phone}</span>}
                          {lead.address && <span style={{ color:"#9ca3af" }}>📍 {lead.address}</span>}
                        </div>
                        <div style={{ display:"flex", gap:12, fontSize:12, flexWrap:"wrap", alignItems:"center" }}>
                          {lead.rating > 0 && <span style={{ color:"#f59e0b" }}>⭐ {lead.rating} <span style={{ color:"#6b7280" }}>({lead.total_ratings} reviews)</span></span>}
                          {lead.website && <a href={lead.website} target="_blank" rel="noreferrer" style={{ color:"#a855f7", textDecoration:"none" }}>🌐 Website</a>}
                          {lead.reason && <span style={{ color:"#6b7280", fontStyle:"italic" }}>🤖 {lead.reason}</span>}
                        </div>
                      </div>
                      {/* Badges */}
                      <div style={{ display:"flex", flexDirection:"column", gap:6, alignItems:"flex-end", flexShrink:0 }}>
                        <span style={{ background:sc+"22", color:sc, border:"1px solid "+sc+"44", borderRadius:8, padding:"4px 12px", fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>{lead.source}</span>
                        <span style={{ background:ist.bg, color:ist.color, border:"1px solid "+ist.border, borderRadius:8, padding:"4px 12px", fontSize:11, fontWeight:700, textTransform:"uppercase" }}>{lead.intent||"warm"}</span>
                        {lead.score >= 80 && <span style={{ background:"#00d4aa18", color:"#00d4aa", border:"1px solid #00d4aa44", borderRadius:6, padding:"2px 8px", fontSize:10, fontWeight:700 }}>HIGH VALUE</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Post-search upgrade */}
            {status.remaining <= 0 && leads.length > 0 && (
              <div style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"2px solid #00d4aa44", borderRadius:24, padding:36, marginTop:24, textAlign:"center" }}>
                <div style={{ fontSize:40, marginBottom:12 }}>🔒</div>
                <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:24, fontWeight:900, marginBottom:10 }}>Both Free Searches Used</h3>
                <p style={{ color:"#9ca3af", fontSize:15, maxWidth:440, margin:"0 auto 24px", lineHeight:1.6 }}>
                  Liked the results? Upgrade to get 500–Unlimited real leads every month from all 4 platforms, with AI scoring and automatic delivery to your email.
                </p>
                <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
                  <button onClick={() => navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:12, padding:"14px 40px", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:16, cursor:"pointer" }}>
                    🚀 Upgrade — See Plans
                  </button>
                  <button onClick={() => navigate("/dashboard")} style={{ background:"transparent", color:"#9ca3af", border:"1px solid #ffffff22", borderRadius:12, padding:"14px 24px", fontFamily:"'DM Sans',sans-serif", fontWeight:500, fontSize:15, cursor:"pointer" }}>
                    Dashboard →
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
